import api from '@/services/api/api'

class AuthorsService {
  getAllAuthors () {
    return api.get('author').then(result => {
      return result.data
    })
  }

  saveAuthor (author) {
    return api.post('author', author)
  }

  removeAuthor (author) {
    return api.delete('author/' + author.id)
  }
}

export default new AuthorsService()



// WEBPACK FOOTER //
// ./src/services/codebooks/AuthorsService.js